module.exports = __webpack_public_path__ + "img/stock0.dfa6c8f5.png";